"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var SVG = function SVG(props) {
  return react_1["default"].createElement("svg", {
    className: props.className,
    height: props.height,
    width: props.width,
    viewBox: '0 0 103 28',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
  }, react_1["default"].createElement("g", null, react_1["default"].createElement("clipPath", {
    id: 'clip0'
  }, react_1["default"].createElement("rect", {
    width: '102.667',
    height: '28',
    fill: '#fff'
  })), react_1["default"].createElement("path", {
    fill: '#161D24',
    d: 'M10.7566 27.6014L2.96976 19.3686V27.6014H0V1.58228H2.96976V17.9225L10.3564 10.2363H14.1714L6.00949 18.6399L14.4429 27.6014H10.7566Z'
  }), react_1["default"].createElement("path", {
    fill: '#161D24',
    d: 'M17.6003 5.06101C17.5729 4.31722 17.9474 3.61769 18.5766 3.23752C19.2058 2.85735 19.989 2.85735 20.6181 3.23752C21.2473 3.61769 21.6219 4.31722 21.5945 5.06101C21.5543 6.1532 20.672 7.01752 19.5974 7.01752C18.5227 7.01752 17.6405 6.1532 17.6003 5.06101ZM18.1125 10.2364H21.0823V27.6014H18.1125V10.2364Z'
  }), react_1["default"].createElement("path", {
    fill: '#161D24',
    d: 'M41.5289 16.9375V27.6014H38.5592V17.1112C38.5592 14.2644 36.9554 12.6646 34.3243 12.6646C31.5924 12.6646 29.3728 14.2958 29.3728 18.395V27.6014H26.4031V10.2363H29.3728V12.7357C30.6352 10.6861 32.5133 9.78369 34.9037 9.78369C38.9063 9.78369 41.5289 12.4938 41.5289 16.9375Z'
  }), react_1["default"].createElement("path", {
    fill: '#161D24',
    d: 'M47.4679 18.6105C48.0928 13.2729 52.0622 9.25186 57.0655 9.25186C59.3397 9.25186 61.2831 10.2838 62.2886 11.9563L63.405 2.41972L60.2602 1.38778L60.2838 1.18614L65.6009 0L62.4893 26.5813H65.2533L65.1908 27.1151L60.425 27.8268L60.7457 25.0868C59.3129 26.866 57.0145 27.9691 54.6703 27.9691C49.8012 27.9691 46.8265 24.0904 47.4679 18.6105ZM55.625 26.9371C57.5029 26.9741 59.3987 26.1515 60.7915 24.6954L62.2286 12.4188C61.209 10.9392 59.5119 10.0995 57.6261 10.1415C53.3926 10.1415 50.2387 13.771 49.6763 18.5749C49.1223 23.3076 51.4265 26.9371 55.625 26.9371Z'
  }), react_1["default"].createElement("path", {
    fill: '#161D24',
    d: 'M70.0784 20.5319L71.228 10.7107L68.5923 10.2125L68.6506 9.71436H73.269L72.0402 20.2117C71.4903 24.9088 72.7343 26.7354 75.9649 26.7354C78.9038 26.7354 81.456 24.6597 81.9795 20.1879L83.0889 10.7107L80.4881 10.2125L80.5464 9.71436H85.1298L83.1554 26.5812H85.9544L85.8919 27.115L81.0853 27.8267L81.6976 22.5958C80.5563 26.3677 77.8614 27.969 74.9108 27.969C71.0271 27.969 69.466 25.7628 70.0784 20.5319Z'
  }), react_1["default"].createElement("path", {
    fill: '#161D24',
    d: 'M88.9207 27.0438L90.4335 26.9726C91.3823 26.937 91.6789 26.7947 91.7622 26.083L93.427 11.8613L90.8188 10.8293L90.8438 10.6158L95.6476 9.42969L94.9978 14.9808C96.2857 10.853 99.1422 9.46527 102.326 9.46527H102.571L102.325 11.5647L101.319 11.4936C96.983 11.1733 95.1436 13.7354 94.7687 16.9379L93.6968 26.0949C93.6135 26.8066 93.8884 26.9489 94.9572 26.9845L97.1531 27.0557L97.092 27.5776H88.8699L88.9207 27.0438Z'
  })));
};

exports["default"] = SVG;
/* eslint-enable */